/* The Naturalz welcome page — acceptance step logic.
   BROWSER-SAFE Omnisend wiring via the Omnisend JavaScript API. No API key is
   placed in the page. On submit we identify + subscribe the creator, attach the
   tag "The Naturalz Creator" (plus "Content Reuse OK"), and fire a
   "creator joined" custom event. Then we reveal the confirmation.

   REQUIRES the Omnisend app (its web-tracking snippet) on the store so that
   window.omnisend exists. If it is missing, the creator still proceeds — nothing
   is blocked. To GUARANTEE the tag regardless of SDK behavior, add a one-step
   Omnisend automation:  Trigger = custom event "creator joined"  ->
   Action = add tag "The Naturalz Creator".  Loaded by sections/kn-naturalz.liquid. */
(function(){
  var root = document.querySelector('.kn-nz');
  if(!root || root.dataset.knInit) return;
  root.dataset.knInit = '1';

  var modal   = root.querySelector('[data-kn-modal]');
  var form    = root.querySelector('[data-kn-form]');
  var done    = root.querySelector('[data-kn-done]');
  var emailEl = root.querySelector('[data-kn-email]');
  var reqEl   = root.querySelector('[data-kn-required]');
  var optEl   = root.querySelector('[data-kn-optional]');
  var errEl   = root.querySelector('[data-kn-err]');
  var submit  = root.querySelector('[data-kn-submit]');
  var lastFocus = null;

  function openModal(){
    lastFocus = document.activeElement;
    modal.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function(){ try{ emailEl.focus(); }catch(e){} }, 60);
  }
  function closeModal(){
    modal.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if(lastFocus){ try{ lastFocus.focus(); }catch(e){} }
  }
  function showErr(msg){ errEl.textContent = msg; errEl.classList.add('is-shown'); }
  function clearErr(){ errEl.textContent = ''; errEl.classList.remove('is-shown'); }

  root.querySelectorAll('[data-kn-open]').forEach(function(b){ b.addEventListener('click', openModal); });
  modal.querySelectorAll('[data-kn-close]').forEach(function(b){ b.addEventListener('click', closeModal); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && modal.classList.contains('is-open')) closeModal(); });

  function validEmail(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  function tagInOmnisend(email, allowRepost){
    var tags = ['The Naturalz Creator'];
    if(allowRepost) tags.push('Content Reuse OK');
    try {
      window.omnisend = window.omnisend || [];
      window.omnisend.push(["identifyContact", {
        email: email,
        tags: tags,
        channels: { email: { status: "subscribed", statusDate: new Date().toISOString() } }
      }]);
      window.omnisend.push(["track", "$customEvent", "creator joined", {
        email: email,
        allow_repost: !!allowRepost
      }]);
    } catch (e) {}
  }

  form.addEventListener('submit', function(e){
    e.preventDefault();
    clearErr();
    var email = (emailEl.value || '').trim();
    if(!validEmail(email)){ showErr('Please enter a valid email address.'); emailEl.focus(); return; }
    if(!reqEl.checked || !optEl.checked){ showErr('Please agree to both boxes to continue.'); return; }

    submit.disabled = true;
    submit.textContent = 'Claiming your spot...';
    tagInOmnisend(email, optEl.checked);

    setTimeout(function(){
      form.style.display = 'none';
      done.classList.add('is-shown');
    }, 500);
  });
})();
